module.exports = "dist/videos/help/advanced-block-vertical-align.mp4";